import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {Member} from '../models/member';
import {MemberFileDialogComponent} from './dialogs/member-file-dialog/member-file-dialog.component';
import {MemberService} from '../services/member.service';
import {Category} from '../models/category';
import {CategoryService} from '../services/category.service';
import {RegionalService} from '../services/regional.service';
//import {MemberDialog2Component} from './dialogs/member-dialog2/member-dialog2.component';
import {MemberViewerDialogComponent} from './dialogs/member-viewer-dialog/member-viewer-dialog.component';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {AnnotationService} from '../services/annotation.service';
import {SubcategoryHistoryService} from '../services/subcategory-history.service';
import {MemberLinksService} from '../services/member-links.service';
import {MatPaginator} from '@angular/material/paginator';
import {FileService} from '../services/file.service';
import {MemberDialogComponent} from './dialogs/member-dialog/member-dialog.component';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: [ './member.component.scss' ],
  entryComponents: [
    MemberDialogComponent
  ]
})
export class MemberComponent implements OnInit {

  public dataSource =  new MatTableDataSource<Member>([]);
//  public members$: any;
  public displayedColumns: string[] = [ 'icon', 'situation', 'name', 'subCategory', 'balance', 'credit', 'staff', 'push', 'zzversion', 'mkt', 'edit2', 'viewer' ];

  public allCategories: Category[] = [];

  // public arrayMembers: Member[] = []

  public userLogged: any;


  constructor (
    private _memberLinksService: MemberLinksService,
    public _memberService: MemberService,
    private _categoryService: CategoryService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    public _regionalService: RegionalService,
    private _spinnerService: SpinnerService,
    private _annotationService: AnnotationService,
    private _fileService: FileService,
    private _subcategoryHistoryService: SubcategoryHistoryService) {
  }

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  private destroy$ = new Subject<void>();

  ngOnInit () {
    const waiting = this._spinnerService.show();

    //this.members$ = this._memberService.loadAll();
    this._memberService.loadAll()
      .pipe(takeUntil(this.destroy$)) // Segurança para fechar o canal ao sair
      .subscribe(data => {
       // console.log(JSON.stringify(data))
        this.dataSource.data = data;
         this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        waiting.close();
      });

    //this.loadMembers()

    this.loadCategories()
    
  }

  ngOnDestroy () {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCategory_name (category_id): string {

    let cat = this.allCategories.find((e) => {
      return e.id == category_id
    })

    if (cat)
      return cat.name
    else
      return ""
  }

  loadCategories () {

    this._categoryService.select()
      .subscribe((result) => {
        result.forEach((item) => {

          const cat = new Category();
          cat.id = item.payload.doc.id
          cat.name = item.payload.doc.data().name
          this.allCategories.push(cat)

        })

      })

  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialog (entity) {

    let data: Member = new Member();

    if (entity) {
      data = entity;
    }

    this.dialog.open(MemberDialogComponent, {
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

  }

  /*
  openDialog2 (entity) {

    let data: Member = new Member();

    if (entity) {
      data = entity;
    }

    this.dialog.open(MemberDialog2Component, {
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

  }
  */

  openFileDialog () {

    this.dialog.open(MemberFileDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      // data: userData
    });
  }


  exportToCsv () {

    const data = this.dataSource.data;

    let csvFile: any[] = []

    csvFile.push("" + ";" + "Usuários SBCCV" + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'

    csvHeader += 'Categoria' + ';'
    csvHeader += 'Vigência' + ';'

    csvHeader += 'Situação' + ';'
    csvHeader += 'Saldo' + ';'

    csvHeader += 'Endereço' + ';'
    csvHeader += 'Número' + ';'
    csvHeader += 'Complemento' + ';'

    csvHeader += 'Cidade' + ';'
    csvHeader += 'UF' + ';'
    csvHeader += 'Pais' + ';'
    csvHeader += 'CEP' + ';'

    csvHeader += 'CPF' + ';'
    csvHeader += 'Celular' + ';'
    csvHeader += 'E-mail' + ';'
    csvHeader += 'Push' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((line) => {


      //  csvLine += "" + ";"
      //  csvLine += this.selectedProduct.name + ";"
      let csvLine: string;

      csvLine = "" + ";"
      csvLine += line.name + ";"
      csvLine += (line.subCategory ? line.subCategory.name : '') + ";"
      csvLine += line.annuity_from + ";"
      csvLine += line.situation + ";"
      csvLine += line.balance + ";"

      csvLine += line.address + ";"
      csvLine += line.number + ";"
      csvLine += line.complement + ";"

      csvLine += line.city + ";"
      csvLine += line.state + ";"
      csvLine += line.country + ";"

      csvLine += line.postalCode + ";"
      csvLine += line.cpf + ";"

      csvLine += line.cellPhone + ";"

      csvLine += line.email + ";"

      if (line.push) {
        csvLine += 'Sim' + "\r\n"
      } else {
        csvLine += 'Não' + "\r\n"
      }

      csvFile.push(csvLine)

    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
    this._fileService.saveFile(blob, "membros.csv");

  }


  openViewerDialog (entity) {

    let data: Member = new Member();

    if (entity) {
      data = entity;
    }

    this.dialog.open(MemberViewerDialogComponent, {
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

  }


  annotationsToCSV () {
    const waiting = this._spinnerService.show();
    let count: number = 0;

    let csvFile: any[] = []

    csvFile.push("" + ";" + "Anotações Usuários SBCCV" + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'
    csvHeader += 'Categoria' + ';'
    csvHeader += 'Data' + ';'
    csvHeader += 'Texto' + ';'
    csvHeader += 'Status' + '\r\n'

    csvFile.push(csvHeader)

    this._annotationService.loadByName()
      .subscribe((result) => {
        result.forEach((item) => {

          const member = this.dataSource.data.find((e) => {
            return e.id === item.data().member_id
          })

          let csvLine: string;
          const dt: any = item.data().date

          csvLine = "" + ";"
          csvLine += item.data().member_name.trim() + ";"
          csvLine += member ? member.subCategory.name + ";" : "" + ";"
          csvLine += this.formatDate(dt.toDate()) + ";"
          csvLine += item.data().text.trim().replace(/;/g, ',').replace(/[\x00-\x1F\x7F]/g, ' ') + ";"
          csvLine += this.convertStatus(item.data().status) + "\r\n"
          csvFile.push(csvLine)
          count++
        })

        var BOM = "\ufeff";
        let csvData = BOM + csvFile;

        var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
        this._fileService.saveFile(blob, "anotações_membros.csv");

        waiting.close()

      })
  }

  convertStatus (status) {
    let result = ''
    switch (status) {
      case 0:
        result = 'None';
        break;
      case 1:
        result = 'Pendente';
        break;
      case 2:
        result = 'Finalizado';
        break;
      default:
        result = '-'
        break;
    }
    return result
  }

  categoriesToCSV () {
    const waiting = this._spinnerService.show();
    let count: number = 0;

    let csvFile: any[] = []

    csvFile.push("" + ";" + "Categorias Usuários SBCCV" + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'
    csvHeader += 'Categoria Atual' + ';'
    csvHeader += 'Data' + ';'
    csvHeader += 'Categoria Histórico' + ';'
    csvHeader += 'Anuidade' + '\r\n'

    csvFile.push(csvHeader)

    this._subcategoryHistoryService.loadHistory()
      .subscribe((result) => {
        result.forEach((item) => {

          const member = this.dataSource.data.find((e) => {
            return e.id === item.data().member_id
          })

          let csvLine: string;
          const dt: any = item.data().date

          csvLine = "" + ";"
          csvLine += item.data().member_name.trim() + ";"
          csvLine += member ? member.subCategory.name + ";" : "" + ";"
          csvLine += this.formatDate(dt.toDate()) + ";"
          csvLine += item.data().subcategory_name + ";"
          csvLine += this.convertAnnuity(item.data().subcategory_annuity) + "\r\n"
          csvFile.push(csvLine)
          count++
        })

        var BOM = "\ufeff";
        let csvData = BOM + csvFile;

        var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
        this._fileService.saveFile(blob, "categorias_membros.csv");

        waiting.close()

      })
  }

  linksToCSV () {

    const waiting = this._spinnerService.show();
    let count: number = 0;

    let csvFile: any[] = []

    csvFile.push("" + ";" + "Links Usuários SBCCV" + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'
    csvHeader += 'Categoria' + ';'
    csvHeader += 'Data' + ';'
    csvHeader += 'Texto' + ';'
    csvHeader += 'Link' + '\r\n'

    csvFile.push(csvHeader)

    this._memberLinksService.loadByName()
      .subscribe((result) => {
        result.forEach((item) => {

          const member = this.dataSource.data.find((e) => {
            return e.id === item.data().member_id
          })

          let csvLine: string;
          const dt: any = item.data().date

          csvLine = "" + ";"
          csvLine += item.data().member_name.trim() + ";"
          csvLine += member ? member.subCategory.name + ";" : "" + ";"
          csvLine += this.formatDate(dt.toDate()) + ";"
          csvLine += item.data().text.trim().replace(/;/g, ',').replace(/[\x00-\x1F\x7F]/g, ' ') + ";"
          csvLine += item.data().link + "\r\n"
          csvFile.push(csvLine)
          count++
        })

        var BOM = "\ufeff";
        let csvData = BOM + csvFile;

        var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
        this._fileService.saveFile(blob, "links_membros.csv");

        waiting.close()

      })
  }

  convertAnnuity (annuity: boolean) {
    let result: string = 'Não'
    if (annuity) {
      result = 'Sim';
    }
    return result
  }

  formatDate (dt: Date) {
    const dd: number = dt.getDate()
    const mm: number = dt.getMonth() + 1
    const yy: number = dt.getFullYear()

    let ddStr = dd.toString()
    let mmStr = mm.toString()
    let yyStr = yy.toString()

    if (ddStr.length < 2) ddStr = '0' + ddStr
    if (mmStr.length < 2) mmStr = '0' + mmStr

    const data: string = ddStr + '/' + mmStr + '/' + yyStr
    //console.log(data)

    return data
  }

}
